export interface CrashReportSummaryFilter {
  itemNumber: string;
  agent: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  location: string;
}

export function getNulledOutCrashReportSummaryFilter(): CrashReportSummaryFilter {
  return {
    itemNumber: null,
    agent: null,
    startDate: null,
    endDate: null,
    startTime: null,
    endTime: null,
    location: null,
  };
}
